import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=3b8bac3d&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8bac3d')) {
      api.createRecord('3b8bac3d', component.options)
    } else {
      api.reload('3b8bac3d', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=3b8bac3d&", function () {
      api.rerender('3b8bac3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24N98mfpOBa4T/JS/comp/stardisplay.vue"
export default component.exports